import { render, staticRenderFns } from "./Valora.vue?vue&type=template&id=76062e12&"
import script from "./Valora.vue?vue&type=script&lang=js&"
export * from "./Valora.vue?vue&type=script&lang=js&"
import style0 from "./Valora.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports